export const environment = {
  production: true,
  url: 'https://servicedeskexternows.tjba.jus.br/',
  packageFile: './../../../../package.json',
  VERSION: require('../../package.json').version,
  tokenChatBot: '5e73786bce2b00001746a931',
  idcategoriaAdvogadoDelegatario: '400834',
  idCategoriaProjudi: '418634',
  idcategoriaDelegatarioCoarcExtrajudicial: '418702',
  idcategoriaDelegatarioNucleoExtrajudicial: '418703',
  idCategoriaPje: '418635'
};
